export default {
      id: "icon-msg-usage",
      viewBox: "0 0 24 24",
      url: "/" + "assets/sprite.svg#icon-msg",
      toString: function () {
        return this.url;
      }
    }